import React, {useState}                            from 'react';

const zeroPad = h => { 
    if ( Number.isInteger( h ) ){
        let pad = '000' + h; 
        return pad.substr(pad.length - 2, 2) 
    }else{
        return '00';
    }
}

/* Internal component to choose between appointment types and also to edit the 
 * start and end times */
const TimeEdit = ({name,value,onChange}) => {
    
    // convert to date if it's not already
    const dateValue = (value instanceof Date)? value: new Date( value );
    
    const [hourVal,     setHourVal] =                     useState( zeroPad( dateValue.getHours() ) );
    const [minuteVal,   setMinuteVal] =                   useState( zeroPad( dateValue.getMinutes() ) );
    
    const doChange = (hour,minute) => {
        
        const newTime = new Date( dateValue.getFullYear(), dateValue.getMonth(), 
            dateValue.getDate(), hour, minute );
            
        onChange( name, newTime );
    }
    
    const handleMinuteChange = e => {
        
        let minute = Number.parseInt( e.target.value, 10 );
        
        if ( Number.isNaN( minute ) ){
            minute = '';
        }else if (minute > 59){
            minute = 59;
        }else if (minute < 0){
            minute = 0;
        }
        
        setMinuteVal( minute );
        doChange(hourVal, minute);
    }
    
    const handleHourChange = e => {
        
        let hour = Number.parseInt( e.target.value, 10 );
        
        if ( Number.isNaN( hour ) ){
            hour = '';
        }else if (hour > 23){
            hour = 23;
        }else if (hour < 0){
            hour = 0;
        }
        
        setHourVal( hour );
        doChange(hour, minuteVal);
    }
    
    return (
            <div >
                <input value={hourVal} 
                    onChange={handleHourChange} style={{marginRight: '.2em'}} 
                    onBlur={e=>setHourVal( zeroPad(hourVal) )}
                    size='2' type='integer'  />
                
                
                
                <input value={minuteVal} 
                    onBlur={e=>setMinuteVal( zeroPad(minuteVal) )}
                    onChange={handleMinuteChange} size='2' type='integer' />
                       
                
            </div>
    )
}

/**
 * REACT componentg to show two time edit boxes, usualy one for start time and 
 * one for end time. 
 * @returns {undefined}
 */
const TwoTimeEdit = ({start, end, onStartChange, onEndChange, startLabel, endLabel}) => {
    
    const [error,setError]                    = useState('');
    
    const timeChange = (name,time) => {
        
        const errMsg = 'End time must not be less than start time';
        
        setError('');
        if('start' === name){
            if( end.getTime() < time.getTime() ){
                setError(errMsg);
            }else{                
                onStartChange(time);
            }
        }else{
            if( time.getTime() < start.getTime() ){
                setError(errMsg);
            }else{
                onEndChange(time);
            }
        }
    }
    
    return <div className='wrapper'>
        
        <div className='fBlock' >
            <label>{startLabel}</label>
            <TimeEdit name='start' value={start} onChange={timeChange} />
        </div>
        <div className='fBlock'>
            <label>{endLabel}</label>
            <TimeEdit name='end' value={end} onChange={timeChange}  />
        </div>
        
        {error? <p>{error}</p>: null}
    </div>
}

export {TwoTimeEdit}
export default TimeEdit